module.exports = __webpack_public_path__ + "img/exclamation.d0598844.svg";